<template>
  <div class="myApi">
    <div class="title">申请API</div>
    <div class="box" v-if="list.length > 0">
      <div class="item" v-for="item in list" :key="item.id" @click="$router.push(`/apiMargetDetail/${item.id}`)">
        <img :src="item.imgUrl" alt="" class="item-img" />
        <div>
          <div class="item-name item-bottom">{{ item.name }}</div>
          <div class="item-bottom">申请赠送：{{ item.defaultCount }}次</div>
        </div>
        <button
          class="nowApplyBtn"
          :disabled="item.applied"
          :class="{ disableClick: item.applied }"
          @click="(e) => applyFree(e, item.id)"
        >
          立即申请
        </button>
      </div>
    </div>
    <div v-else class="noData">
      <img :src="emptyUrl" alt="" class="url" />
      <span class="content">暂无数据</span>
    </div>
  </div>
</template>

<script>
import { applyApiList, applyInterface } from '@/api/common'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      list: {}
    }
  },
  computed: {
    ...mapState(['emptyUrl'])
  },
  methods: {
    async applyFree (event, id) {
      // 调用获取方法
      const result = await applyInterface(id)

      event.target.classList.add('disableClick')
      event.target.disabled = true
      // 获取到按钮的dom对象，增加类
      this.$toast.success(result.data)
    }
  },
  async created () {
    const result = await applyApiList()
    this.list = result.data
  }
}
</script>

<style lang="less" scoped>
.myApi {
  width: 100%;
  padding: 30px 40px;
  .title {
    color: #333;
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 22px;
  }
  .noData {
    display: flex;
    // 修改主轴方向；row（默认值，水平方向）column：垂直方向
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .url {
      width: 500px;
      height: 300px;
    }
    .content {
      color: #cacdd1;
    }
  }
  .box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .item {
      display: flex;
      align-items: center;
      width: 49%;
      border: 1px solid #eee;
      margin-bottom: 30px;
      padding: 20px;
      .nowApplyBtn {
        padding: 3px 8px;
        margin-left: 150px;
        background-color: #00bdff;
        font-size: 16px;
        color: #fff;
        border-radius: 6px;
        cursor: pointer;
        border: none;
      }
      .disableClick {
        background: #a7aaa5;
      }
      .item-name {
        font-size: 18px;
      }
      .item-bottom {
        margin-bottom: 5px;
      }
      .item-img {
        width: 50px;
        height: 50px;
        margin-right: 40px;
      }
    }
  }
}
</style>
